import React, { useState, Fragment, useCallback } from 'react';
import { Box, Button, Typography } from '@mui/material';
import Stack from '@mui/material/Stack';
import { Scrollbar } from 'react-scrollbars-custom';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
const HeaderWrapper = ({ children }) => {
  return (
    <Stack alignItems="center" justifyContent="center" spacing="8px">
      {children}
    </Stack>
  );
};

const ContentFooter = ({ children }) => {
  return <Box mb="1rem">{children}</Box>;
};

const Steps = ({
  children,
  initialKey,
  handleCancel,
  nextHandler,
  prevHandler,
  skipHandler,
  riderLoading,
}) => {
  const steps = children;
  const handlePrev = useCallback(() => {
    prevHandler?.();
  }, [prevHandler]);
  const handleNext = useCallback(() => {
    nextHandler?.();
  }, []);

  const handleFinish = () => {
    nextHandler?.();
  };

  const handleSkip = useCallback(() => {
    skipHandler?.();
  }, [skipHandler]);

  return (
    <Box className="steps">
      <Stack>
        <HeaderWrapper>
          {steps.map((step, index) => {
            return initialKey !== ++index ? null : (
              <Fragment key={`${step.props.label}-${index}`}>
                <Box component="div">
                  <Typography variant="h4">{step.props.label}</Typography>
                </Box>
                {step.props.description && <Box component="div">{step.props.description}</Box>}
              </Fragment>
            );
          })}
        </HeaderWrapper>

        <Scrollbar style={{ width: '100%', minHeight: '500px', maxHeight: '1000px' }}>
          <Stack spacing="1.5rem" sx={{ margin: '.5rem' }}>
            {steps.map((step, index) => (
              <Fragment key={step.props.tabKey}>
                {React.cloneElement(step, { ...step.props, activeTabKey: initialKey })}
              </Fragment>
            ))}
            {steps.map((step, index) => {
              return initialKey !== ++index ? null : (
                <Fragment key={`${step.props.footer}-${index}`}>
                  {step.props.footer && <Box component="div">{step.props.footer}</Box>}
                </Fragment>
              );
            })}
          </Stack>
        </Scrollbar>
        <>
          {steps.map((step, index) => {
            return initialKey !== ++index ? null : (
              <Fragment key={`${step.props.label}-${index}`}>
                {step.props.error && (
                  <Box component="div">
                    <Stack
                      direction="row"
                      spacing=".5em"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <ErrorOutline color="primary" />
                      <Typography color="red">{step.props.error}</Typography>
                    </Stack>
                  </Box>
                )}
              </Fragment>
            );
          })}
        </>
        <Stack direction="row" spacing="1em" alignItems="center" justifyContent="center">
          <Button color="error" variant="outlined" onClick={handleCancel}>
            Cancel
          </Button>
          {initialKey >= 3 && (
            <Button disabled={riderLoading} onClick={handlePrev} variant="outlined" color="primary">
              Back
            </Button>
          )}

          {initialKey === steps.length ? (
            <Button disableElevation variant="contained" onClick={handleFinish}>
              Finish
            </Button>
          ) : (
            <Button variant="outlined" disabled={riderLoading} onClick={handleNext}>
              Next
            </Button>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export default Steps;
